import { els } from './dom.js';
import { getSelectedMode } from './controls.js';

export function getVideoSubmitBlockReason(state) {
  if (state.activeTaskId) return '当前视频任务还在生成中，请稍候。';
  if (!state.referenceImages.length) return '请先上传或选择参考图。';
  if (getSelectedMode(state) === 'firstLast' && !state.lastFrame) return '首尾帧模式需要上传尾帧图。';
  if (!els.prompt()?.value.trim()) return '请先填写视频创意描述。';
  return '';
}
